import { render } from "./FolderOpenOutline.vue?vue&type=template&id=818555ec"
import script from "./FolderOpenOutline.vue?vue&type=script&lang=js"
export * from "./FolderOpenOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__